import { PlaneTakeoff } from "lucide-react";
import PlaceholderPage from "./PlaceholderPage";

export default function BookingTools() {
  return (
    <PlaceholderPage 
      title="Booking Tools" 
      description="Access specialized tools for booking flights, hotels, activities, and other travel components for your clients."
      icon={<PlaneTakeoff size={48} />} 
    />
  );
}